import { useCallback, useEffect, useState } from "react";

import api from "../../services/api";
import { useClient } from "../../hook/useClient";
import { useClientInfo } from "../../hook/useClientInfo";
import PageIntro from "../../components/ui/PageIntro";
import { toTree } from "../Groups/GroupsPanel";
import MembersPanel from "./MembersPanel";

/**
 * Who may read and write the system's discussions, and in which part.
 *
 * The staff panel shows this beside the groups editor and hands it the tree
 * that editor loaded; here it stands alone, so it loads the tree itself. The
 * select only needs names and depth, so one request is enough.
 *
 * The head is worded by how this client lets people in (2026-10-22): with QR
 * a person must be added here first; with the site's ticket a newcomer joins
 * the root group by themselves, and only someone removed here stays out. The
 * old text said a site login never gives access -- wrong for ticket clients.
 */
const MembersPage = () => {
  const { clientId, clientName, canManage } = useClient();
  const info = useClientInfo();
  const [groups, setGroups] = useState([]);
  const [rows, setRows] = useState(null);
  const onRows = useCallback((list) => setRows(list), []);

  useEffect(() => {
    let live = true;
    api
      .get("/groups/", { params: { client: clientId } })
      .then((res) => live && setGroups(toTree(res.data.results || [])))
      .catch(() => live && setGroups([]));
    return () => {
      live = false;
    };
  }, [clientId]);

  const ticket = info?.auth_mode === "ticket";
  const active = rows ? rows.filter((m) => m.is_active) : [];
  const chips = rows
    ? [
        { icon: "tabler:users", label: `${active.length} ta faol`, tone: active.length ? "good" : "warn" },
        ...(ticket
          ? [{ icon: "tabler:sparkles", label: `${active.filter((m) => m.is_auto).length} ta avtomatik qoʻshilgan` }]
          : []),
        { icon: "tabler:clock", label: `${active.filter((m) => !m.has_signed_in).length} ta hali kirmagan` },
        info && {
          icon: ticket ? "tabler:ticket" : "tabler:qrcode",
          label: ticket ? "Kirish: sayt logini" : "Kirish: QR (telefon)",
        },
      ].filter(Boolean)
    : [];

  return (
    <>
      <PageIntro icon="tabler:users-group" title="Ishtirokchilar" readOnly={!canManage} chips={chips}>
        Kirish huquqi PINFL boʻyicha beriladi va <b>guruhga</b> biriktiriladi: u shu guruh va
        uning ichidagi barcha muhokamalarni qamrab oladi. Ildiz guruh — butun tizim.{" "}
        {info &&
          (ticket
            ? "Saytingizga kirgan yangi odam birinchi marta muhokamani ochganda avtomatik ishtirokchi boʻladi; siz olib tashlagan odam esa qayta qoʻshilmaguncha kira olmaydi."
            : "Odamni avval shu yerda qoʻshing — u kim ekanini MySuhbat ilovasida QR kod orqali tasdiqlaydi; saytingizga kirgan boʻlish yetarli emas.")}
      </PageIntro>
      <MembersPanel
        clientId={clientId}
        clientName={clientName}
        groups={groups}
        canEdit={canManage}
        onRows={onRows}
      />
    </>
  );
};

export default MembersPage;
